import { useCallback } from 'react';

import { useDispatch } from 'react-redux';

import { getUser, clearLicenseStateChannel } from './actions';

function useAuth() {
  const dispatch = useDispatch();

  const handleGetUser = useCallback(() => {
    dispatch(getUser());
  }, [dispatch]);

  const handleResetUser = useCallback(() => {
    dispatch(getUser.reset());
  }, [dispatch]);

  const handleClearLicenseStateChannel = useCallback(() => {
    dispatch(clearLicenseStateChannel());
  }, [dispatch]);

  return {
    loadGetUser: handleGetUser,
    resetGetUser: handleResetUser,
    clearLicenseStateChannel: handleClearLicenseStateChannel,
  };
}

export default useAuth;
